import { addOrSubtractDaysFromDate } from '@/app/helpers/utils'

const bitbucketImg = 'assets/images/brands/bitbucket.svg'
const dribbleImg = 'assets/images/brands/dribbble.svg'
const dropboxImg = 'assets/images/brands/dropbox.svg'
const githubImg = 'assets/images/brands/github.svg'
const slackImg = 'assets/images/brands/slack.svg'
const smImg3 = 'assets/images/small/img-3.jpg'
const smImg4 = 'assets/images/small/img-4.jpg'
const smImg6 = 'assets/images/small/img-6.jpg'
const avatar1 = 'assets/images/users/avatar-1.jpg'
const avatar3 = 'assets/images/users/avatar-3.jpg'
const avatar5 = 'assets/images/users/avatar-5.jpg'
const avatar6 = 'assets/images/users/avatar-6.jpg'
const avatar7 = 'assets/images/users/avatar-7.jpg'

export type BootstrapVariantType =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'danger'
  | 'warning'
  | 'info'
  | 'dark'
  | 'light'

export type FileType = Partial<File> & {
  preview?: string
}

export type ActivityType = {
  title: string
  icon?: string
  variant?: BootstrapVariantType
  status?: 'completed' | 'latest'
  files?: FileType[]
  time: Date
  type?: 'task' | 'design' | 'achievement'
  content?: string
}

export type AppType = {
  image: string
  name: string
  handle: string
}

export type NotificationType = {
  from: string
  content: string
  icon?: string
}

export const appsData: AppType[] = [
  {
    image: githubImg,
    name: 'Github',
    handle: '@Project',
  },
  {
    image: bitbucketImg,
    name: 'Bitbucket',
    handle: '@Project',
  },
  {
    image: dribbleImg,
    name: 'Dribble',
    handle: '@username',
  },
  {
    image: dropboxImg,
    name: 'Dropbox',
    handle: '@username',
  },
  {
    image: slackImg,
    name: 'Slack',
    handle: '@Project',
  },
]


export const activityStreamData: ActivityType[] = [
  {
    title: 'Report-Fix / Update',
    variant: 'danger',
    type: 'task',
    files: [
      {
        name: 'Concept.fig',
      },
      {
        name: 'Project.docs',
      },
    ],
    time: addOrSubtractDaysFromDate(0),
  },
  {
    title: 'Project Status',
    files: [
      {
        name: 'UI/UX Figma Design.fig',
      },
    ],
    variant: 'success',
    type: 'design',
    status: 'completed',
    time: addOrSubtractDaysFromDate(1),
  },
  {
    title: 'Project Application UI v1.0.0',
    variant: 'primary',
    content:
      'Get access to over 20+ pages including a dashboard layout, charts, kanban board, calendar, and pre-order E-commerce & Marketing pages.',
    files: [{ name: 'Backup.zip' }],
    status: 'latest',
    time: addOrSubtractDaysFromDate(3),
  },
  {
    title: 'Alex Smith Attached Photos',
    icon: avatar7,
    time: addOrSubtractDaysFromDate(4),
    files: [{ preview: smImg6 }, { preview: smImg3 }, { preview: smImg4 }],
  },
  {
    title: 'Rebecca J. added a new team member',
    icon: avatar6,
    time: addOrSubtractDaysFromDate(4),
    content: 'Added a new member to Front Dashboard',
  },
  {
    title: 'Achievements',
    variant: 'warning',
    type: 'achievement',
    time: addOrSubtractDaysFromDate(5),
    content: 'Earned a "Best Product Award"',
  },
]
